import axios from "axios";
// import { requestHmlWx } from "@/assets/hmlapi.js";

export default {
	namespaced: true, // 当 namespaced 设置为true之后引入在index中的时候不会与其他相同名称的数据或方法发生冲突
	state: {
        firstLevelIndex: -1, // 一级索引
        secondLevelIndex: 0, // 二级索引
        levelThreeIndex: 0, // 三级索引
        allData: null, // 后台获取的所有数据
        staticeData: null, // 静态资源，配置项等
        pageShow: false, // app页面显示状态
        playAroundDetailsFlag: false, // 玩转二级显示状态
        getIntoTheState: 0, // 进入状态，0代表首页进入 1代表列表进入 2代表详情进入
        mapJumpListFlag: false, // 跳转状态，从地图详情进入二级页面所需的数据
        specialtyState: false,
        foodState: false,
        swiperNum: 0,
        indexGetIntoState: false,
        shoppingFlag: false,
        urlFlag: false,
        tuceIndex: 0,
	},
	mutations: {
        setTuceIndex(state,index){
            state.tuceIndex = index;
        },
        setUrlFlag(state){
            state.urlFlag = true;
        },
        setShoppingFlag(state,flag){
            state.shoppingFlag = flag;
        },
        obtainData(state){
            let time = Date.parse(new Date());
            let dataUrl = "https://hmltec.oss-cn-beijing.aliyuncs.com/jingshan/staticState/data.json?time="+time;
            axios.get(dataUrl).then(res => {
                // requestHmlWx(res.data.option.wxshareData);
                state.staticeData = res.data;
                console.log(state.staticeData);
                let publicUrl = "https://hmltec.com/cms/index.php?m=api&c=index&a=query&site=京山&position=";
                state.allData = res.data.allData;
                state.allData.forEach((item,index) => {
                    item.dataArr.forEach((value,j) => {
                        axios.get(publicUrl + value.requestName).then(res => {
                            let str = "";
                            res.data.forEach((element,ind) => {
                                // if(index == 2){
                                //     console.log(element.title + element.vtour);
                                // }
                                str += element.title;
                                // console.log(element.content);
                                if(element.gps){
                                    if(index == 3){
                                        element.gpsIndex = j;
                                    }
                                    let gpsStr = element.gps;
                                    res.data[ind].gps = [
                                        parseFloat(gpsStr.split(",")[0]),
                                        parseFloat(gpsStr.split(",")[1])
                                    ]
                                }
                            })
                            value.list.push(...res.data);
                            let flag = true;
                            for(let i = 0; i < state.allData.length; i++){
                                for(let j = 0; j < state.allData[i].dataArr.length; j++){
                                    if(state.allData[i].dataArr[j].list.length == 0){
                                        flag = false;
                                        break;
                                    }
                                }
                            }
                            if(flag){
                                state.pageShow = true;
                                // console.log(state.allData);
                                
                            }
                            // console.log(str);
                        });
                    });
                    
                });
                 
            });
        },
        addDataSort(state){
            
        },
        setIndex(state,options){ // 改变索引
            if(options.firstLevelIndex == undefined){
                options.firstLevelIndex = state.firstLevelIndex
            }else{
                 // console.log("一级索引发生了变化,新的索引是",options.firstLevelIndex);
                state.firstLevelIndex = options.firstLevelIndex;
            }
            if(options.secondLevelIndex == undefined){
                options.secondLevelIndex = state.secondLevelIndex
            }else{
                state.secondLevelIndex = options.secondLevelIndex;
                 // console.log("二级索引发生了变化,新的索引是",options.secondLevelIndex);
            }
            if(options.levelThreeIndex == undefined){
                options.levelThreeIndex = state.levelThreeIndex
            }else{
                state.levelThreeIndex = options.levelThreeIndex;
                 // console.log("三级索引发生了变化,新的索引是",options.levelThreeIndex);
            }
             // console.log({
            //     firstLevelIndex: state.firstLevelIndex,
            //     secondLevelIndex: state.secondLevelIndex,
            //     levelThreeIndex: state.levelThreeIndex,
            // });
        },
        setPlayAroundDetailsFlag(state,flag){
            state.playAroundDetailsFlag = flag;
        },
        setGetIntoTheState(state,flag){
            state.getIntoTheState = flag;
        },
        setMapJumpListFlag(state,flag){
            state.mapJumpListFlag = flag;
        },
        setSpecialtyState(state,flag){
            state.specialtyState = flag;
        },
        setfoodState(state,flag){
            state.foodState = flag;
        },
        setSwiperNum(state,num){
            state.swiperNum = num;
        },
        setIndexGetIntoState(state){
            state.indexGetIntoState = true;
        },
    }
}